// Error magnitude (minutes) -> band class, defined in Predictions.css (.err-good /
// .err-warn / .err-bad / .err-very-bad, all theme variables). Shared by the arrivals and
// departures tables so one error reads the same colour on both.
export function errorToBandClass(errorMin) {
  const e = Math.abs(errorMin);
  if (e <= 1) return 'err-good';
  if (e <= 2) return 'err-warn';
  if (e <= 5) return 'err-bad';
  return 'err-very-bad';
}
